import axiosWrapper from "@AxiosWrapper";
import { getBackendUrl } from "@Utils";
import type {
  GetDirectoryDataOfFileRequest,
  GetDirectoryDataOfFileResponse,
} from "@ServerTypes/fileOperations/fileOperations.schemas";

/** Single source for the directory-data endpoint path (previously duplicated across call sites). */
export const GET_DIRECTORY_DATA_OF_FILE_PATH = "/fileOperations/getDirectoryDataOfFile";

/**
 * Thin wrapper around the `getDirectoryDataOfFile` POST. Centralises the endpoint path + payload
 * shape so the three callers (the FileVersion panel, the transmittal-references panel, and the
 * viewer children-name lookup) stay in sync. Each caller keeps its own dispatch / toast /
 * stale-response (`ignore`) handling, which differs per site and must not move into the shared fetch.
 */
export async function fetchDirectoryDataOfFile(
  where: GetDirectoryDataOfFileRequest["value"]["where"],
  transmittalId?: string,
): Promise<GetDirectoryDataOfFileResponse> {
  const payload: GetDirectoryDataOfFileRequest = {
    value: { where },
    ...(transmittalId ? { transmittalId } : {}),
  };
  const response = await axiosWrapper.post<GetDirectoryDataOfFileResponse>(
    `${getBackendUrl()}${GET_DIRECTORY_DATA_OF_FILE_PATH}`,
    payload,
  );
  return response.data;
}
